import React from "react";
import { Paper, Typography, makeStyles } from "@material-ui/core";
import tokens from "../designTokens";

const useStyles = makeStyles({
  root: {
    border: `1px solid ${tokens.border}`,
    borderRadius: tokens.radiusDefault,
    overflow: "hidden",
  },
  head: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 },
  title: { fontFamily: tokens.fontHeading, fontWeight: 600, fontSize: 16, color: tokens.textPrimary },
  subtitle: { fontFamily: tokens.fontBody, fontSize: 12.5, color: tokens.textSecondary, marginTop: 4 },
  actions: { display: "flex", alignItems: "center", gap: 8, flexShrink: 0 },
});

// Hairline-bordered white tile — Paper with the page's outlined look.
export default function Card({ title, subtitle, actions, children, padding = 20, style, bodyStyle, ...rest }) {
  const classes = useStyles();
  return (
    <Paper variant="outlined" className={classes.root} style={style} {...rest}>
      {(title || actions) && (
        <div className={classes.head} style={{ padding: `${padding}px ${padding}px 0` }}>
          <div style={{ minWidth: 0 }}>
            {title && <Typography component="div" className={classes.title}>{title}</Typography>}
            {subtitle && <Typography component="div" className={classes.subtitle}>{subtitle}</Typography>}
          </div>
          {actions && <div className={classes.actions}>{actions}</div>}
        </div>
      )}
      <div style={{ padding, ...bodyStyle }}>{children}</div>
    </Paper>
  );
}
